import { isEmpty } from 'ramda'
import { useTranslation } from 'react-i18next'

export default function usePasswordValidation(options?: {
  firstFieldName?: string
  secondFieldName?: string
}) {
  const { t } = useTranslation()

  const firstFieldName = options?.firstFieldName ?? 'password'
  const secondFieldName = options?.secondFieldName ?? 'password1'

  const compareToFirstPassword = ({
    getFieldValue,
  }: {
    getFieldValue: any
  }) => ({
    validator(_: any, value: any) {
      if (value && value !== getFieldValue(firstFieldName)) {
        const msg = t('user:password not equal')

        return Promise.reject(msg)
      } else {
        return Promise.resolve()
      }
    },
  })

  const validateToNextPassword = ({
    getFieldValue,
  }: {
    getFieldValue: any
  }) => ({
    validator(_: any, value: any) {
      if (
        value &&
        !isEmpty(getFieldValue(secondFieldName) || '') &&
        value !== getFieldValue(secondFieldName)
      ) {
        const msg = t('user:password not equal')
        return Promise.reject(msg)
      }
      return Promise.resolve()
    },
  })

  return {
    validateToNextPassword,
    compareToFirstPassword,
  }
}
